import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'WomanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-woman",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 16v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 16v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 16h8l-2 -7h-4z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 11c1.667 -1.333 3.333 -2 5 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19 11c-1.667 -1.333 -3.333 -2 -5 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode(" ")]);
  }
};